"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoanDetailsPage = void 0;

var _utils = require("@navinc/utils");

var _underlineTable = require("../common/underline-table");

var _common = require("./common");

var _detailList = require("./detail-list");

var _qualifiersList = require("../common/qualifiers-list");

var _proCon = require("./pro-con");

var _recommendation = require("./recommendation");

var _jsxRuntime = require("react/jsx-runtime");

var ThreeColumnUnderlineTable = (0, _underlineTable.createUnderlineTable)({
  gridTemplateColumns: '1fr 1fr 1fr'
});
var TwoColumnUnderlineTable = (0, _underlineTable.createUnderlineTable)({
  gridTemplateColumns: '1fr 2fr'
});

var LoanDetailsPage = function LoanDetailsPage(_ref) {
  var _navEditorial$recomme, _loanOffer$navEditori, _loanOffer$navEditori2, _loanOffer$qualifiers, _loanOffer$navEditori3, _loanOffer$navEditori4, _loanOffer$navEditori5, _loanOffer$navEditori6;

  var loanOffer = _ref.loanOffer,
      _ref$disableApplyOnMa = _ref.disableApplyOnMatchFactorZero,
      disableApplyOnMatchFactorZero = _ref$disableApplyOnMa === void 0 ? false : _ref$disableApplyOnMa,
      onApplyClick = _ref.onApplyClick,
      compareOffersHref = _ref.compareOffersHref,
      category = _ref.category,
      locationUrl = _ref.locationUrl,
      enterpriseUuid = _ref.enterpriseUuid,
      referralName = _ref.referralName,
      referralTarget = _ref.referralTarget,
      referralType = _ref.referralType,
      client = _ref.client,
      showExtrapolatedToolTip = _ref.showExtrapolatedToolTip,
      _ref$shouldShowMatchF = _ref.shouldShowMatchFactorDescriptionDrawer,
      shouldShowMatchFactorDescriptionDrawer = _ref$shouldShowMatchF === void 0 ? false : _ref$shouldShowMatchF;

  if (!loanOffer) {
    return null;
  }

  var matchFactorScore = loanOffer.matchFactor;
  var shouldHideApply = disableApplyOnMatchFactorZero && matchFactorScore === 0;

  var internalOnApplyClick = function internalOnApplyClick() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      matchFactorScore: matchFactorScore,
      mfSource: loanOffer.mfSource,
      accountId: enterpriseUuid,
      offerCategory: 'loans',
      offerId: loanOffer.id,
      offerName: loanOffer.name,
      offerSubCategory: '',
      offerBrand: loanOffer.issuer,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: loanOffer.rtid,
      rsid: loanOffer.rsid,
      offerLink: loanOffer.applyUrl,
      partnerId: '',
      client: client,
      value: 0
    });
    return !!onApplyClick && onApplyClick(loanOffer);
  };

  var Buttons = function Buttons() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.ApplyButton, {
        shouldHide: shouldHideApply,
        applyUrl: loanOffer.applyUrl,
        onClick: internalOnApplyClick
      }), compareOffersHref && /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.CompareOffersButton, {
        href: compareOffersHref
      })]
    });
  };

  var specifics = loanOffer.specifics,
      navEditorial = loanOffer.navEditorial;
  var details = [specifics === null || specifics === void 0 ? void 0 : specifics.fundingAmount, specifics === null || specifics === void 0 ? void 0 : specifics.cost, specifics === null || specifics === void 0 ? void 0 : specifics.fundingSpeed, specifics === null || specifics === void 0 ? void 0 : specifics.repaymentTerms, specifics === null || specifics === void 0 ? void 0 : specifics.originationFee, specifics === null || specifics === void 0 ? void 0 : specifics.application].filter(_utils.id).map(function (_ref2) {
    var category = _ref2.category,
        description = _ref2.description;
    return {
      title: category,
      description: description
    };
  });
  var recommendation = (_navEditorial$recomme = navEditorial === null || navEditorial === void 0 ? void 0 : navEditorial.recommendation) !== null && _navEditorial$recomme !== void 0 ? _navEditorial$recomme : navEditorial === null || navEditorial === void 0 ? void 0 : navEditorial.summary;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.StyledStandardCard, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.PageHeader, {
      offer: loanOffer,
      buttons: /*#__PURE__*/(0, _jsxRuntime.jsx)(Buttons, {}),
      shouldShowMatchFactorDescriptionDrawer: shouldShowMatchFactorDescriptionDrawer
    }), ((_loanOffer$navEditori = loanOffer.navEditorial) === null || _loanOffer$navEditori === void 0 ? void 0 : _loanOffer$navEditori.summary) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.BlueStripe, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.PreLineCopy, {
          bold: true,
          children: (_loanOffer$navEditori2 = loanOffer.navEditorial) === null || _loanOffer$navEditori2 === void 0 ? void 0 : _loanOffer$navEditori2.summary
        })
      })
    }), loanOffer.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.MarginTopSection, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.PreLineCopy, {
        children: loanOffer.description
      })
    }), ((_loanOffer$qualifiers = loanOffer.qualifiers) === null || _loanOffer$qualifiers === void 0 ? void 0 : _loanOffer$qualifiers.length) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.Section, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.SectionHeader, {
        children: "Here's what you need to qualify"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ThreeColumnUnderlineTable, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_qualifiersList.QualifiersList, {
          qualifiers: loanOffer.qualifiers,
          showExtrapolatedToolTip: showExtrapolatedToolTip
        })
      })]
    }), details.length && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.Section, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.SectionHeader, {
        children: "Loan Details"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TwoColumnUnderlineTable, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailList.DetailList, {
          details: details
        })
      })]
    }), (((_loanOffer$navEditori3 = loanOffer.navEditorial) === null || _loanOffer$navEditori3 === void 0 ? void 0 : _loanOffer$navEditori3.pros) || ((_loanOffer$navEditori4 = loanOffer.navEditorial) === null || _loanOffer$navEditori4 === void 0 ? void 0 : _loanOffer$navEditori4.cons)) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.Section, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.SectionHeader, {
        children: "Pros and Cons"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_proCon.ProCon, {
        navEditorial: loanOffer.navEditorial
      })]
    }), recommendation && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.Section, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.SectionHeader, {
        children: "Our Recommendation"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recommendation.Recommendation, {
        recommendation: recommendation
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.FooterApplyContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Buttons, {})
    }), ((_loanOffer$navEditori5 = loanOffer.navEditorial) === null || _loanOffer$navEditori5 === void 0 ? void 0 : _loanOffer$navEditori5.termsAndConditions) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_common.Section, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_common.SectionHeader, {
        size: "sm",
        children: "Terms & Conditions"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.PreLineCopy, {
        size: "sm",
        children: (_loanOffer$navEditori6 = loanOffer.navEditorial) === null || _loanOffer$navEditori6 === void 0 ? void 0 : _loanOffer$navEditori6.termsAndConditions
      })]
    })]
  });
};

exports.LoanDetailsPage = LoanDetailsPage;
//# sourceMappingURL=loan-details-page.js.map